import type { ReactNode } from "react";
import type { JourneyRow } from "@/types";

type Props = {
  journey: JourneyRow;
  onWatch?: (journey: JourneyRow) => void;
};

export default function JourneyStatusLabel({ journey, onWatch }: Props) {
  const watchable = Boolean(journey.watchable && onWatch);

  if (journey.evaluation_status === "failed") {
    return (
      <WatchableStatus watchable={watchable} onWatch={() => onWatch?.(journey)} className="text-error">
        Evaluation failed
      </WatchableStatus>
    );
  }

  if (journey.evaluation_status === "evaluating") {
    return (
      <WatchableStatus watchable={watchable} onWatch={() => onWatch?.(journey)} className="text-primary animate-pulse">
        Evaluating
      </WatchableStatus>
    );
  }

  if (journey.evaluation_status === "completed") {
    return (
      <WatchableStatus watchable={watchable} onWatch={() => onWatch?.(journey)} className="text-gray-700">
        Evaluation complete
      </WatchableStatus>
    );
  }

  return <span className="text-sm font-medium text-gray-500">Not evaluated</span>;
}

function WatchableStatus({
  watchable,
  onWatch,
  className,
  children,
}: {
  watchable: boolean;
  onWatch: () => void;
  className: string;
  children: ReactNode;
}) {
  if (!watchable) {
    return <span className={`text-sm font-medium ${className}`}>{children}</span>;
  }

  return (
    <button
      type="button"
      className={`cursor-pointer text-sm font-medium hover:underline hover:underline-offset-[3px] ${className}`}
      aria-label="Watch evaluation in player"
      onMouseDown={(event) => event.preventDefault()}
      onClick={onWatch}
    >
      {children}
    </button>
  );
}
